var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-cascader',{ref:"townSelect",attrs:{"options":_vm.townTree,"filterable":""},on:{"change":_vm.parentChange},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }